module.exports = require("angular-resource");